import { render } from "./MountainStage.vue?vue&type=template&id=3f1d83ba"
import script from "./MountainStage.vue?vue&type=script&lang=js"
export * from "./MountainStage.vue?vue&type=script&lang=js"

import "./MountainStage.vue?vue&type=style&index=0&id=3f1d83ba&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__